import request from "../request";

/**
 * Получить доступные бонусы в корзине
 * @param {Number} orderId
 * @return {Promise<Number>}
 */

export const getOrderBonuses = (orderId) => {
  return request({
    url: `/loyalty/get-bonuses-by-order?order_id=${orderId}`
  });
};

/**
 * Получить кол-во бонусов
 * @return {Promise<Number>}
 */

export const getBonuses = () => {
  return request({
    url: "/loyalty/get-bonuses"
  });
}

/**
 * Применить бонусы
 * @param {Number} order_id
 * @param {Number} bonuses
 * @return {Promise}
 */

export const payWithBonuses = (order_id, bonuses) => {
  return request({
    url: `/loyalty/distribution-bonuses?order_id=${order_id}&bonuses=${bonuses}`,
  });
}

/**
 * Возврат бонусов
 * @param order_id {Number} - id заказа
 * @return {Promise}
 */
export const undistributionBonuses = (order_id) => {
  return request({
    url: `/loyalty/undistribution-bonuses?order_id=${order_id}`,
  });
}